export type LegacySmsMessageType = 'SMS' | 'LMS' | 'MMS'

export const LEGACY_SMS_MAX_BYTES = 2000
export const LEGACY_SMS_SHORT_MESSAGE_BYTES = 90

/**
 * Matches the legacy gf15_HLEN_UTF8 rule used by the Django sender:
 * ASCII/one-byte characters are 1, a line-feed is 2, and each UTF-16
 * non-Latin code unit is 2 (so an emoji surrogate pair is 4).
 */
export function getLegacySmsBytes(value: string) {
  let bytes = 0

  for (let index = 0; index < value.length; index += 1) {
    const codeUnit = value.charCodeAt(index)

    if (codeUnit === 0x0a) {
      bytes += 2
    } else if (codeUnit <= 0xff) {
      bytes += 1
    } else {
      bytes += 2
    }
  }

  return bytes
}

export function truncateLegacySmsMessage(value: string, maxBytes = LEGACY_SMS_MAX_BYTES) {
  let result = ''
  let usedBytes = 0

  for (const character of Array.from(value)) {
    const nextBytes = getLegacySmsBytes(character)
    if (usedBytes + nextBytes > maxBytes) break
    result += character
    usedBytes += nextBytes
  }

  return { value: result, bytes: usedBytes, truncated: result !== value }
}

export function getLegacySmsMessageType(bytes: number, mmsSelected: boolean): LegacySmsMessageType {
  if (mmsSelected) return 'MMS'
  return bytes >= LEGACY_SMS_SHORT_MESSAGE_BYTES ? 'LMS' : 'SMS'
}

export function getLegacySmsByteLimit(bytes: number, type: LegacySmsMessageType) {
  if (type === 'SMS') return LEGACY_SMS_SHORT_MESSAGE_BYTES
  if (type === 'MMS' && bytes < LEGACY_SMS_SHORT_MESSAGE_BYTES) return LEGACY_SMS_SHORT_MESSAGE_BYTES
  return LEGACY_SMS_MAX_BYTES
}

export function validateLegacySmsReservation(date: string, time: string, now = new Date()) {
  if (!date || !time) return '예약 일시를 지정해주세요.'

  const reservation = new Date(`${date}T${time}:00`)
  if (Number.isNaN(reservation.getTime()) || reservation <= now) {
    return '예약 일시는 현재 시간보다 이전으로 <br>설정할 수 없습니다.'
  }

  return null
}
